import classnames from "classnames";
import type { ReactNode } from "react";

export const DetailsItemGrid = ({
  className,
  children,
  columns = 2,
}: {
  className?: string;
  children?: ReactNode;
  columns?: 2 | 4;
}) => {
  const colClass = columns === 4 ? "xl:grid-cols-4" : "xl:grid-cols-2";

  return (
    <dl
      className={classnames(
        `flex flex-col xl:grid gap-4 ${colClass}`,
        className,
      )}
    >
      {children}
    </dl>
  );
};
